/* Combatra OpenAI storefront measurement. CAPI credentials stay server-side. */
(function () {
  "use strict";
  var tag = document.getElementById("cbr-openai-measurement");
  if (!tag || window.top !== window || window.__cbrOpenAiInstalled) return;
  var config;
  try { config = JSON.parse(tag.textContent); } catch (_) { return; }
  if (!config.enabled) { tag.dataset.state = "disabled-qa"; return; }
  if (!config.pixelId || window.Shopify && window.Shopify.designMode) return;
  window.__cbrOpenAiInstalled = true;
  var storageKey = "cbr_oai_click_v1", allowed = false, initialized = false, pageSent = false;
  var privacy = null, lastStamp = "", priorReference = null, stampQueue = Promise.resolve(), hasCartStamp = !!config.hadConsentStamp;
  var consentKey = "__cbr_oai_consent__", referenceKey = "__cbr_oai_oppref__", expiryKey = "__cbr_oai_expires__";
  var consentAtKey = "__cbr_oai_consent_at__", consentUntilKey = "__cbr_oai_consent_until__";
  tag.dataset.state = "waiting-consent";
  function state(value) { tag.dataset.state = value; }
  function readStored() {
    try { return JSON.parse(localStorage.getItem(storageKey) || "null"); } catch (_) { return null; }
  }
  function removeStored() { try { localStorage.removeItem(storageKey); } catch (_) {} }
  function originalReference() {
    if (!allowed) return null;
    var now = Date.now(), existing = readStored(), incoming = new URL(window.location.href).searchParams.get("oppref");
    if (incoming && incoming.length <= 4096 && !/[\u0000-\u001f\u007f]/.test(incoming)) {
      existing = { value: incoming, expires: now + 30 * 86400000 };
      try { localStorage.setItem(storageKey, JSON.stringify(existing)); } catch (_) {}
    }
    if (!existing || typeof existing.value !== "string" || !existing.value || existing.value.length > 4096 || /[\u0000-\u001f\u007f]/.test(existing.value) || !Number.isFinite(existing.expires) || existing.expires <= now || existing.expires > now + 30 * 86400000) {
      removeStored(); return null;
    }
    priorReference = existing;
    return existing;
  }
  function stamp(reference, grant) {
    var at = Date.now(), until = at + 86400000;
    var signature = grant ? "allowed:" + at + ":" + (reference ? reference.value + ":" + reference.expires : "no-reference") : "clear";
    if (signature === lastStamp) return;
    var attrs = {};
    attrs[consentKey] = grant ? "v1:allowed" : "";
    attrs[consentAtKey] = grant ? String(at) : "";
    attrs[consentUntilKey] = grant ? String(until) : "";
    attrs[referenceKey] = reference ? reference.value : "";
    attrs[expiryKey] = reference ? String(reference.expires) : "";
    lastStamp = signature;
    stampQueue = stampQueue.catch(function () {}).then(function () {
      if (grant && !allowed) { lastStamp = ""; return; }
      return fetch(config.cartUpdateUrl, {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) {
        if (!r.ok) throw new Error("cart-reference-not-saved");
        hasCartStamp = grant;
        tag.dataset.cartReference = grant ? (reference ? "saved" : "consent-only") : "cleared";
      }).catch(function () { lastStamp = ""; tag.dataset.cartReference = "not-saved"; });
    });
  }
  function eventId() {
    return "cbr_web_" + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + "_" + Math.random().toString(36).slice(2));
  }
  function measure(name, data) {
    if (!allowed || !initialized) return;
    window.oaiq("measure", name, data, { event_id: eventId(), opt_out: true });
    tag.dataset.lastEvent = name;
  }
  function initialize() {
    if (initialized) return true;
    if (window.oaiq) { state("existing-pixel-detected"); return false; }
    var queue = function () { queue.q.push(arguments); };
    queue.q = [];
    window.oaiq = queue;
    window.oaiq("consent", false);
    window.oaiq("init", { pixelId: config.pixelId });
    var script = document.createElement("script");
    script.async = true;
    script.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
    script.onload = function () { state(allowed ? "sdk-loaded" : "consent-denied"); };
    script.onerror = function () { state("sdk-load-failed"); };
    document.head.appendChild(script);
    initialized = true;
    return true;
  }
  function syncConsent() {
    var next = false;
    try {
      next = privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) {}
    allowed = next;
    if (!next) {
      if (initialized) window.oaiq("consent", false);
      var previous = priorReference || readStored();
      removeStored();
      if (previous || hasCartStamp || lastStamp.indexOf("allowed:") === 0) stamp(null, false);
      priorReference = null;
      state("consent-denied");
      return;
    }
    var ref = originalReference();
    stamp(ref, true);
    if (!initialize()) return;
    window.oaiq("consent", true);
    state("active");
    if (!pageSent) {
      pageSent = true;
      measure("page_viewed", { type: "contents" });
      if (config.product && config.product.id && Number.isInteger(config.product.amount)) {
        measure("contents_viewed", { type: "contents", amount: config.product.amount, currency: config.currency, contents: [config.product] });
      }
    }
  }
  document.addEventListener("ajaxProduct:added", function (event) {
    var p = event.detail && event.detail.product;
    if (!allowed || !p || !p.id || !Number.isInteger(p.quantity) || p.quantity < 1) return;
    var price = Number.isInteger(p.final_price) ? p.final_price : p.price;
    if (!Number.isInteger(price) || price < 0) return;
    measure("items_added", {
      type: "contents", amount: price * p.quantity, currency: config.currency,
      contents: [{ id: p.sku || "gid://shopify/ProductVariant/" + p.id, quantity: p.quantity, amount: price, currency: config.currency }]
    });
    var ref = originalReference();
    stamp(ref, true);
  });
  function usePrivacy() {
    if (!window.Shopify || !Shopify.customerPrivacy) return false;
    privacy = Shopify.customerPrivacy;
    document.addEventListener("visitorConsentCollected", syncConsent);
    syncConsent();
    return true;
  }
  function waitForPrivacy(attempt) {
    if (usePrivacy()) return;
    if (attempt < 40) setTimeout(function () { waitForPrivacy(attempt + 1); }, 250);
    else state("privacy-api-unavailable");
  }
  function boot(attempt) {
    if (usePrivacy()) return;
    if (window.Shopify && Shopify.loadFeatures) {
      tag.dataset.privacyLoader = "requested";
      Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.2" }], function (error) {
        // Another Shopify app can be loading v0.1 already. Reuse its API once ready;
        // do not reload it or grant consent when loadFeatures reports a conflict.
        tag.dataset.privacyLoader = error ? "waiting-existing-api" : "callback-ok";
        waitForPrivacy(0);
      });
    } else if (attempt < 20) setTimeout(function () { boot(attempt + 1); }, 250);
    else { tag.dataset.privacyLoader = "loader-unavailable"; state("privacy-api-unavailable"); }
  }
  boot(0);
})();
